import { render, staticRenderFns } from "./DropdownCompany.vue?vue&type=template&id=2d64e036&"
import script from "./DropdownCompany.vue?vue&type=script&lang=js&"
export * from "./DropdownCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports